import { useEffect } from "react";
import { MiStackedTypography } from "@miplatform/components";
import { Box, Divider, useTheme } from "@mui/material";
import { MaterialCard } from "../../../../../components/MaterialCard/MaterialCard";
import { useAdderCardViewModel } from "./useAdderCardViewModel";

export function AdderCard({ data, isReadOnly, getMenuOptions, stateManager }) {
  const {
    adderData: { items, categories, areas },
    getAdderData,
  } = useAdderCardViewModel({ stateManager, data });
  const theme = useTheme();

  useEffect(() => {
    getAdderData();
  }, []);

  return (
    <MaterialCard
      item={data}
      menuData={!isReadOnly && getMenuOptions(data)}
      customBgColor={data.removed && theme.palette.red.light}
      renderCustomDetails={
        <Box style={{ display: "flex", gap: theme.spacing(2) }}>
          <MiStackedTypography
            title="Description"
            descriptionProps={{
              children: data.manufacturerDescription || "--",
            }}
          />
          <Divider orientation="vertical" flexItem />
          <MiStackedTypography
            title="Items"
            descriptionProps={{ children: items.length || "0" }}
          />
          <Divider orientation="vertical" flexItem />
          <MiStackedTypography
            title="Categories"
            descriptionProps={{ children: categories.length || "0" }}
          />
          <Divider orientation="vertical" flexItem />
          <MiStackedTypography
            title="Areas"
            descriptionProps={{ children: areas.length || "0" }}
          />
        </Box>
      }
    />
  );
}
